import WasherProvisory from './WasherProvisory';

export default WasherProvisory;